<template>
  <b-tab title="Relatório de Inspeção" :active="ativo" class="m-0 p-0">
    <div id="screen-form" class="pl-2 pr-2 mt-2">
      <div id="RelatorioInspecao">
        <b-container fluid>
          <!-- :::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::: -->
          <!-- :::::::::::::::::::::: PARTE SUPERIOR DO RELATORIO ::::::::::::::::::::: -->
          <!-- :::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::: -->
          <b-row>
            <b-col cols="3">
              <b-img
                :src="require('/static/images/netech.png')"
                fluid
                alt="Responsive image"
                width="230"
              />
            </b-col>

            <b-col cols="6" class="pt-1">
              <h4 class="exo-2 center-text p-4">
                RELATÓRIO DE INSPEÇÃO DE EQUIPAMENTO
              </h4>
            </b-col>

            <b-col cols="3" class="pl-5">
              <b-row><p class="m-0 p-0">ID. Relatório</p></b-row>
              <b-row><b-form-input size="sm" v-model="ri.numero" /></b-row>
              <b-row><p class="m-0 p-0">Data</p></b-row>
              <b-row>
                <b-form-datepicker
                  size="sm"
                  v-model="ri.data"
                  :date-format-options="{
                    year: 'numeric',
                    month: 'numeric',
                    day: 'numeric',
                  }"
                />
              </b-row>
            </b-col>
          </b-row>
          <!-- :::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::: -->
          <!-- ::::::::::::::::::::: PARTE IMAGENS DO RELATORIO ::::::::::::::::::::::: -->
          <!-- :::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::: -->
          <b-row class="mt-2">
            <b-col cols="12" class="p-0">
              <div class="separador-div">
                <strong>REGISTRO FOTOGRÁFICO</strong>
              </div>
            </b-col>
          </b-row>
          <b-row v-if="fotos == 'single'">
            <b-col cols="12" class="p-0">
              <div class="p-2 m-0">
                <b-img
                  :src="
                    imagemA == null
                      ? require('/static/images/report.png')
                      : imagemA
                  "
                  class="mt-2 max-size"
                  center
                  fluid
                />
              </div>
            </b-col>
          </b-row>
          <b-row v-if="fotos == 'double'">
            <b-col cols="6" class="p-0">
              <div class="p-2 m-0">
                <b-img
                  :src="
                    imagemA == null
                      ? require('/static/images/default.png')
                      : imagemA
                  "
                  class="mt-2 max-size"
                  center
                  fluid
                />
              </div>
            </b-col>
            <b-col cols="6" class="p-0">
              <div class="p-2 m-0">
                <b-img
                  :src="
                    imagemB == null
                      ? require('/static/images/blank.png')
                      : imagemB
                  "
                  @dblclick="fotos = 'single'"
                  class="mt-2 max-size"
                  center
                  fluid
                />
              </div>
            </b-col>
          </b-row>

          <b-row class="mt-2">
            <b-col cols="6" class="m-0">
              <b-row class="m-0">
                <b-col cols="12" class="p-0">
                  <div class="separador-div">
                    <strong>INFORMAÇÕES SOBRE O EQUIPAMENTO</strong>
                  </div>
                </b-col>
                <b-col cols="12" class="text-left p-0">
                  <p class="m-0 p-0">Descrição / Description</p>
                </b-col>
                <b-col cols="12" class="p-0">
                  <b-form-input size="sm" v-model="equipamento.nome" />
                </b-col>
                <b-col cols="12" class="text-left p-0">
                  <p class="m-0 p-0">Identificação / Identification</p>
                </b-col>
                <b-col cols="12" class="p-0">
                  <b-form-input size="sm" v-model="identificacao" />
                </b-col>
                <b-col cols="12" class="text-left p-0">
                  <p class="m-0 p-0">Dimensões / Dimensions</p>
                </b-col>
                <b-col cols="12" class="p-0">
                  <b-form-input size="sm" v-model="equipamento.dimensoes" />
                </b-col>
                <b-col cols="6" class="text-left p-0">
                  <p class="m-0 p-0">Carga de Trabalho / Work load</p>
                </b-col>
                <b-col cols="6" class="text-left p-0 pl-4">
                  <p class="m-0 p-0">Peso / Weight</p>
                </b-col>
                <b-col cols="6" class="p-0">
                  <b-form-input size="sm" v-model="equipamento.carga" />
                </b-col>
                <b-col cols="6" class="p-0 pl-4">
                  <b-form-input size="sm" v-model="equipamento.peso" />
                </b-col>
              </b-row>
            </b-col>
            <!-- :::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::: -->
            <b-col cols="6" class="m-0">
              <b-row class="m-0">
                <b-col cols="12" class="p-0">
                  <div class="separador-div">
                    <strong>DOCUMENTAÇÃO DE REFERÊNCIA</strong>
                  </div>
                </b-col>
                <b-col cols="12" class="text-left p-0">
                  <p class="m-0 p-0">Documento / Document</p>
                </b-col>
                <b-col cols="12" class="p-0">
                  <b-form-input size="sm" v-model="ri.documento.descricao" />
                </b-col>
                <b-col cols="6" class="text-left p-0">
                  <p class="m-0 p-0">Tipo / Type</p>
                </b-col>
                <b-col cols="6" class="text-left p-0 pl-4">
                  <p class="m-0 p-0">Data / Date</p>
                </b-col>
                <b-col cols="6" class="p-0">
                  <b-form-input size="sm" v-model="ri.documento.tipo" />
                </b-col>
                <b-col cols="6" class="p-0 pl-4">
                  <b-form-datepicker
                    size="sm"
                    v-model="ri.documento.data"
                    :date-format-options="{
                      year: 'numeric',
                      month: 'numeric',
                      day: 'numeric',
                    }"
                  />
                </b-col>
                <b-col cols="12" class="text-left p-0">
                  <p class="m-0 p-0">
                    Número - Edição - Revisão / Number - Edition - Review
                  </p>
                </b-col>
                <b-col cols="12" class="p-0">
                  <b-form-input size="sm" v-model="ri.documento.numero" />
                </b-col>
                <b-col cols="6" class="text-left p-0">
                  <p class="m-0 p-0">Material / Material</p>
                </b-col>
                <b-col cols="6" class="text-left p-0 pl-4">
                  <p class="m-0 p-0">Resultado / Inspection</p>
                </b-col>
                <b-col cols="6" class="p-0">
                  <b-form-input size="sm" v-model="ri.material" />
                </b-col>
                <b-col cols="6" class="p-0 pl-4">
                  <b-form-input size="sm" v-model="ri.resultado" />
                </b-col>
              </b-row>
            </b-col>
          </b-row>
          <!-- :::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::: -->
          <!-- ::::::::::::::::::::: PARTE DETALHES DO RELATORIO :::::::::::::::::::::: -->
          <!-- :::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::: -->
          <b-row>
            <b-col cols="12" class="p-0 mt-2">
              <div class="separador-div">
                <strong>OBSERVAÇÕES GERAIS</strong>
              </div>
            </b-col>
          </b-row>
          <b-row>
            <b-col cols="12" class="p-0">
              <b-form-textarea
                v-model="ri.observacao"
                :rows="linhas"
                plaintext
              />
            </b-col>
          </b-row>
          <b-row>
            <b-col cols="12" class="p-0 mt-2">
              <div class="separador-div">
                <strong>LEGENDA</strong>
              </div>
            </b-col>
          </b-row>
          <b-row class="bordered text-left pl-4 pb-2 legend">
            <b-col cols="4" class="p-0">
              <p class="m-0 p-0 mt-1 legenda-text">T - TRINCA</p>
              <p class="m-0 p-0 legenda-text">AT - AGRUPAMENTO DE TRINCAS</p>
              <p class="m-0 p-0 legenda-text">TL - TRINCA LONGITUDINAL</p>
              <p class="m-0 p-0 legenda-text">TT - TRINCA TRANSVERSAL</p>
              <p class="m-0 p-0 legenda-text">TR - TRINCA RAMIFICADA</p>
            </b-col>
            <b-col cols="4" class="p-0">
              <p class="m-0 p-0 mt-1 legenda-text">PG - POROSIDADE AGRUPADA</p>
              <p class="m-0 p-0 legenda-text">PO - POROSIDADE</p>
              <p class="m-0 p-0 legenda-text">FA - FALTA DE FUSÃO</p>
              <p class="m-0 p-0 legenda-text">MO - MORDEDURA</p>
              <p class="m-0 p-0 legenda-text">TF - TRINCA DE FADIGA</p>
            </b-col>
            <b-col cols="4" class="p-0">
              <p class="m-0 p-0 mt-1 legenda-text">SO - SOLDA</p>
              <p class="m-0 p-0 legenda-text">MB - METAL BASE</p>
              <p class="m-0 p-0 legenda-text">A - APROVADO</p>
              <p class="m-0 p-0 legenda-text">R - REPROVADO</p>
              <p class="m-0 p-0 legenda-text">NA - NÃO APLICÁVEL</p>
            </b-col>
          </b-row>
          <!-- :::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::: -->
          <!-- ::::::::::::::::::::: PARTE INFERIOR DO RELATORIO :::::::::::::::::::::: -->
          <!-- :::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::: -->
          <b-row class="text-left ml-2 mr-2">
            <b-col cols="4" class="mt-2 p-0 pl-3 pr-3">
              <div class="separador-div">
                <strong>INSPETOR</strong>
              </div>
            </b-col>
            <b-col cols="4" class="mt-2 p-0"> </b-col>
            <b-col cols="4" class="mt-2 p-0 pl-3 pr-3">
              <div class="separador-div">
                <strong>CLIENTE</strong>
              </div>
            </b-col>
          </b-row>
          <b-row class="text-left ml-2 mr-2 mb-2">
            <b-col cols="4">
              <inspetor-stamp
                :profissional="ri.inspetor"
                :preview="stampInspetor"
                :posicao="'6rem'"
                key="insp-stamp-ri"
              />
            </b-col>
            <b-col cols="4" class="m-0 p-0"> </b-col>
            <b-col cols="4">
              <div class="borda-cliente">
                <b-img
                  :src="
                    logoCliente == null
                      ? require('/static/images/sgcq_default.png')
                      : logoCliente
                  "
                  class="rounded-0"
                  fluid
                />
              </div>
            </b-col>
          </b-row>
        </b-container>
      </div>
    </div>
    <!-- ::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::: -->
    <!-- :::::::::::::::::::::::::::: MODAL DE EDIÇÃO :::::::::::::::::::::::::::: -->
    <!-- ::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::: -->
    <ri-modal
      ref="tRelatorioInspecao"
      @loadImagemExtra="loadImagemExtra($event)"
    />
    <imagem-list-modal ref="imgListRI" @loadImagem="loadImagem($event)" />
    <!-- ::::::::::::::: COMANDOS DO RELATÓRIO ::::::::::::::: -->
    <div class="menu-acoes p-2">
      <div id="search-bar">
        <b-col cols="12" class="p-1 pr-0">
          <b-form inline>
            <h4 class="exo-1 m-0 mr-2">SGCQ</h4>
            <b-form-input
              id="sgcq-call"
              type="number"
              size="sm"
              class="m-1 p-1"
              placeholder="Sgcq"
              v-model="sgcq"
            />
            <b-button
              size="sm"
              class="ml-1 pl-2 pr-3"
              variant="primary"
              @click="loadEquipamento()"
            >
              <b-icon
                icon="box-arrow-in-up-right"
                variant="light"
                scale="1.1"
                class="mr-2"
              />Buscar
            </b-button>
            <b-button
              size="sm"
              class="ml-1 pl-2 pr-3"
              variant="info"
              @click="loadDetalhes()"
            >
              <b-icon
                icon="file-earmark-richtext"
                variant="light"
                scale="1.1"
                class="mr-2"
              />Detalhes
            </b-button>
            <b-button
              size="sm"
              class="ml-2 pl-2 pr-3"
              variant="warning"
              v-print="printLaudo"
            >
              <b-icon
                icon="printer"
                variant="light"
                scale="1.1"
                class="mr-2"
              />Imprimir
            </b-button>

            <b-form-radio-group
              id="radio-group-1"
              v-model="fonteDaImagem"
              name="radio-sub-component"
              buttons
              button-variant="outline-light"
              size="sm"
              class="conf-bar"
            >
              <b-form-radio value="equipamento">Equipamento</b-form-radio>
              <b-form-radio value="banco">Banco de Imagem</b-form-radio>
            </b-form-radio-group>

            <b-form-input
              id="size-lines"
              type="number"
              size="sm"
              class="m-1 p-1"
              v-model="linhas"
            />
          </b-form>
        </b-col>
      </div>
    </div>
  </b-tab>
</template>
<script>
import { useSgcqStore } from "@/stores/SgcqStore";
import { storeToRefs } from "pinia";
import { useEquipamentoStore } from "@/stores/EquipamentoStore";
import Files from "@/http/files";
import StampCertificado from "@/components/supports/StampCertificado";
import Cliente from "@/models/Cliente";
import Equipamento from "@/models/Equipamento";
import ImagemListModal from "@/components/modals/imagem/ImagemListModal";
import ReportFields from "@/tools/ReportFields";
import RelatorioInspecao from "@/models_reports/RelatorioInspecao";
import RelatorioInspecaoModal from "@/components/modals/relatorio/RelatorioInspecaoModal";

export default {
  name: "RelatorioInspecaoReport",

  components: {
    "inspetor-stamp": StampCertificado,
    "ri-modal": RelatorioInspecaoModal,
    "imagem-list-modal": ImagemListModal,
  },

  data() {
    return {
      sgcq: 0,
      ativo: false,
      fields: new ReportFields(),
      ri: new RelatorioInspecao(),
      cliente: new Cliente(0, "Novo Cliente", "", "", "", "", "", "", ""),
      equipamento: new Equipamento(
        0,
        "Novo Equipamento",
        "",
        "",
        "",
        "",
        "",
        "",
        "",
        "",
        ""
      ),
      identificacao: "",
      stampInspetor: null,
      logoCliente: null,
      fonteDaImagem: "equipamento",
      fotos: "single",
      imagemA: null,
      imagemB: null,
      printLaudo: {
        id: "RelatorioInspecao",
        popTitle: "SGCQ - Sistema de Gestão e Controle da Qualidade",
      },
      files: new Files(this.$http),
      linhas: 12,
    };
  },

  watch: {
    fonteDaImagem: function (newValue) {
      this.imagemA = null;
      if (newValue == "banco") {
        this.$refs.imgListRI.call();
      }
    },
  },

  methods: {
    loadEquipamento() {
      if (this.sgcq != 0 && this.sgcq != "") {
        this.equipamento.update(this.getBySgcq(this.sgcq)[0]);
        this.cliente.update(this.equipamento.cliente);
        this.equipamentoStore
          .LISTAR_SERVICOS(this.equipamento.sgcq)
          .then(() => {
            let servicoData = new Date(this.getLastServico[0].data);
            this.ri.data = new Date(this.getLastServico[0].data);
            let ano = servicoData.getFullYear();
            this.ri.numero =
              "RN" +
              this.getLastServico[0].id +
              "-" +
              this.sgcq +
              "-" +
              ano +
              "-RI";
            this.identificacao = this.equipamento.sgcq;
            if (
              this.equipamento.codigo != "" &&
              this.equipamento.codigo != "- - -"
            ) {
              this.identificacao =
                this.equipamento.sgcq + " - " + this.equipamento.codigo;
            }

            if (this.fonteDaImagem == "equipamento") {
              //carrega a imagem do equipamento
              this.files
                .downloadEquipamento(this.equipamento.sgcq)
                .then((response) => {
                  const reader = new FileReader();
                  const blob = new Blob([response]);
                  reader.readAsDataURL(blob);
                  reader.onload = (e) => {
                    this.imagemA = e.target.result;
                  };
                });
            }

            //carrega a logomarca do cliente
            this.files.downloadLogo(this.cliente.id).then((response) => {
              const reader = new FileReader();
              const blob = new Blob([response]);
              reader.readAsDataURL(blob);
              reader.onload = (e) => {
                this.logoCliente = e.target.result;
              };
            });
          });
      }
    },

    loadDetalhes() {
      this.$refs.tRelatorioInspecao.call(this.ri);
    },

    loadImagem(imagem) {
      this.imagemA = imagem;
    },

    loadImagemExtra(arquivo) {
      this.fotos = "double";
      const reader = new FileReader();
      const blob = new Blob([arquivo]);
      reader.readAsDataURL(blob);
      reader.onload = (e) => {
        this.imagemB = e.target.result;
      };
    },

    getIdentification() {
      let id = this.equipamento.sgcq;
      if (this.equipamento.codigo != "" && this.equipamento.codigo != "- - -") {
        id = id + " - " + this.equipamento.codigo;
      }
      return id;
    },
  },

  setup() {
    const store = useSgcqStore();
    const equipamentoStore = useEquipamentoStore();
    const { getBySgcq } = storeToRefs(equipamentoStore);
    const { getLastServico } = storeToRefs(equipamentoStore);

    return {
      store,
      equipamentoStore,
      getBySgcq,
      getLastServico,
    };
  },
};
</script>
<style lang="scss" scoped>
#screen-form {
  overflow-y: scroll;
  overflow-x: hidden;
  height: 82vh;
}

.exo-1 {
  font-family: "Exo 2", sans-serif;
  font-optical-sizing: auto;
  font-weight: 600;
  font-style: italic;
  font-size: 1.4rem;
  padding: 0;
  color: white;
}

.exo-2 {
  font-family: "Exo 2", sans-serif;
  font-optical-sizing: auto;
  font-weight: 700;
  font-style: italic;
  font-size: 1.8rem;
  text-align: center;
}

.center-text {
  text-align: center;
}

.separador-div {
  font-family: "Exo 2", sans-serif;
  font-optical-sizing: auto;
  background-color: #003c5a;
  border-radius: 4px;
  color: white;
  text-align: justify; /* For Edge */
  text-align-last: center;
  padding-top: 0.5rem;
  padding-bottom: 0.5rem;
}

.borda-cliente {
  border: 1px solid lightgray;
  border-radius: 3px;
  padding-top: 1rem;
  padding-left: 3rem;
  min-height: 8.8rem;
}

.menu-acoes {
  background-color: #112a4a;
}

.legend {
  border: 1px solid lightgray;
  font-size: 0.8rem;
}

#sgcq-call {
  width: 6rem;
}

#size-lines {
  width: 4rem;
}

.conf-bar {
  margin-left: 15rem;
}

.max-size {
  max-height: 20rem;
}
</style>
